import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from '@/components/icons';

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex items-center">
      <div className="nft-container text-center py-16">
        <div className="label-eyebrow text-[#FC4E2C] mb-3">404 · Page Not Found</div>
        <h1 className="font-display font-extrabold uppercase text-5xl lg:text-7xl text-[#060D9C] leading-[0.95]">
          Wrong turn at the loading dock.
        </h1>
        <p className="mt-5 text-[#060D9C]/75 max-w-xl mx-auto">
          The page you’re looking for doesn’t exist or has been moved. Let’s get you back on the safety line.
        </p>
        <div className="mt-8">
          <Link to="/" className="btn-primary-orange">Go Home <ArrowRight width={16} height={16} /></Link>
        </div>
      </div>
    </div>
  );
}
